module.exports = __webpack_public_path__ + "static/img/quickCreate.a933910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quickCreate.png
// module id = ffb997697869abd6
// module chunks = 59